import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { Link, matchPath, withRouter } from 'react-router-dom';

import EquitySearch from '../../../topic/Equity/components/EquitySearch';

import { reverseRoute } from '../../../public/utils/common';

import { DropdownGroup, DropdownMenu } from '../../../public/components/Action';

import { equityActiveTickerSelector } from '../../selectors/domainData';

import { authenticatedSelector, tokenSelector } from '../../selectors/auth';
import { logoutAction } from '../../action-creators/auth';
import { stopSessionAction } from '../../middlewares/authManager';

import { hideNavbar, pathNames } from '../../constants';

import logo from '../../../img/npstocks-logo.png';
import UserInfo from '../../../topic/UserInfo/views';
import NavMenu from './NavMenu';
import styles from './styles.scss';
import { RestBuilder } from '../../../public/utils/rest';
import { paramsForGet, urlForLogout } from '../../rest';

const mapStateToProps = state => ({
    authenticated: authenticatedSelector(state),
    activeTicker: equityActiveTickerSelector(state),
    token: tokenSelector(state),
});

const mapDispatchToProps = dispatch => ({
    logout: () => dispatch(logoutAction()),
    stopSession: params => dispatch(stopSessionAction(params)),
});

const propTypes = {
    activeTicker: PropTypes.string,
    authenticated: PropTypes.bool,
    logout: PropTypes.func.isRequired,
    stopSession: PropTypes.func.isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string,
    }).isRequired,
};

const defaultProps = {
    activeTicker: undefined,
    authenticated: false,
    token: '',
};

const getKeyByValue = (object, value) => (
    Object.keys(object)
        .find(key => object[key] === value)
);

@withRouter
@connect(mapStateToProps, mapDispatchToProps)
@CSSModules(styles, { allowMultiple: true })
export default class Navbar extends React.PureComponent {
    static propTypes = propTypes;
    static defaultProps = defaultProps;

    // UTILS

    constructor(props) {
        super(props);

        this.state = {
            showUserInfo: false,
            searchExpanded: false,
            token: props.token,
        };
    }

    getCurrentMatch = () => {
        const { location } = this.props;

        const links = Object.keys(pathNames);
        const paths = Object.values(pathNames);

        for (let i = 0; i < links.length; i += 1) {
            const match = matchPath(location.pathname, {
                path: paths[i],
                exact: true,
            });

            if (match) {
                return match;
            }
        }

        return null;
    };

    // NAV links

    getValidNavLinks = () => {
        const navLinks = [
            'overview',
            'portfolio',
            'equity',
            'announcements',
            'comparative',
            'technicalScan',
            'DalalStreet',
            'technicalAnalysis',
        ];

        return navLinks;
    };

    deleteAllCookies = () => {
        const cookies = document.cookie.split(';');
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i];
            const eqPos = cookie.indexOf('=');
            const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            // eslint-disable-next-line prefer-template
            document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.token !== prevState.token) {
        return { token: nextProps.token };
    }
    return null;
}

    createRequestForLogout = (token) => {
    const requestForLogout = new RestBuilder()
        .url(urlForLogout)
        .retryTime(1000)
        .maxRetryTime(10)
        .params(paramsForGet({ token }))
        .success((response) => {
            console.info('SUCCESS', response);
            try {
                console.log(response);
            } catch (er) {
                console.error(er);
            }
        })
        .failure((response) => {
            console.info('FAILURE', response);
        })
        .fatal((response) => {
            console.info('FATAL:', response);
        })
        // TODO: handle failure
        .build();
    return requestForLogout;
}

    handleLogoutButtonClick = async () => {
    const { token } = this.state;
    await this.createRequestForLogout(token);
    await fetch(urlForLogout, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    this.props.stopSession();
    this.props.logout();
};

    handleUserInfoClick = () => {
        this.setState({ showUserInfo: true });
    };

    handleUserInfoClose = () => {
        this.setState({ showUserInfo: false });
    };

    handleSearchExpansion = () => {
        this.setState({ searchExpanded: !this.state.searchExpanded });
    };

    render() {
        const {
            authenticated,
            activeTicker,
        } = this.props;
        const {
            showUserInfo,
            searchExpanded,
        } = this.state;

        const match = this.getCurrentMatch();
        const currentPath = match ? getKeyByValue(pathNames, match.path) : 'fourHundredFour';
        // console.log(currentPath);

        if (!authenticated || hideNavbar[currentPath]) {
            return <div className="no-navbar" />;
        }

        return (
            <nav
                styleName="navbar"
            >
                <Link
                    to={reverseRoute(pathNames.main, {})}
                    styleName="brand"
                >
                    <img src={logo} styleName="logo" alt="npstocks" width={100} height={96} />
                    {/*
                    <span styleName="title">SystemX</span>
                    */}
                </Link>
                <NavMenu
                    links={this.getValidNavLinks()}
                    styleName="main-menu"
                    ticker={activeTicker}
                />
                {
                    authenticated && (
                        <div
                            styleName={searchExpanded ? 'search-box expanded' : 'search-box'}
                        >
                            {searchExpanded &&
                            <EquitySearch
                                styleName="equity-search"
                            />
                            }
                            <button
                                styleName="equity-search-button"
                                onClick={this.handleSearchExpansion}
                            >
                                {searchExpanded ? (
                                    <span className="ion-close" />
                                ) : (
                                    <span className="ion-search" />
                                )}
                            </button>
                        </div>
                    )
                }
                {
                    /* TODO: fix this */
                    authenticated && (
                        <DropdownMenu
                            styleName="dropdown-menu"
                            dropdownClassName={styles['dropdown-container']}
                            iconName="ion-android-contact"
                            title=""
                        >
                            <DropdownGroup>
                                <button
                                    className={styles.button}
                                    onClick={this.handleUserInfoClick}
                                >
                                    <span className="ion-android-contact" />
                                    User Info
                                </button>
                                <Link
                                    to={reverseRoute(pathNames.payment, {})}
                                    className={styles.button}
                                >
                                    <span className="ion-card" />
                                    Payment
                                </Link>
                                <Link
                                    to={reverseRoute(pathNames.newChangePassword, {})}
                                    className={styles.button}
                                >
                                    <span className="ion-key" />
                                    Change Password
                                </Link>
                                {/* <Link
                                    to={reverseRoute(pathNames.Dashboard, {})}
                                    className={styles.button}
                                >
                                    <span className="fa fa-dashboard" />
                                    Referral Dashboard
                                </Link> */}
                                <button
                                    className={styles.button}
                                    onClick={this.handleLogoutButtonClick}
                                >
                                    <span className="ion-log-out" />
                                    Logout
                                </button>
                            </DropdownGroup>
                        </DropdownMenu>
                    )
                }
                {
                    showUserInfo &&
                    <UserInfo
                        onClose={this.handleUserInfoClose}
                    />
                }
            </nav>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/Navbar/index.js